import { MouseEvent, forwardRef, ChangeEvent } from 'react';
import styled from '@emotion/styled';
import { IPaperProps, Paper, getPaperBoxShadow } from './Paper';
import { ITheme, themed } from '../../themer';
import { VisuallyHiddenInput } from '../Input';

export interface IPaperSelectorProps extends IPaperProps {
	name?: string;
	value?: string;
	defaultChecked?: boolean;
	type?: 'radio' | 'checkbox';
	disabled?: boolean;
	onClick?: (e: MouseEvent) => void;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const PaperSelector = forwardRef<HTMLInputElement, IPaperSelectorProps>(
	(
		{
			name,
			type,
			value,
			defaultChecked,
			onClick,
			onChange,
			disabled,
			...props
		}: IPaperSelectorProps,
		ref,
	) => (
		// eslint-disable-next-line jsx-a11y/label-has-associated-control
		<label>
			<VisuallyHiddenInput
				ref={ref}
				name={name}
				value={value}
				onChange={onChange}
				type={type ?? 'checkbox'}
				disabled={disabled}
			/>
			<StyledPaperSelector clickable disabled={disabled} {...props} />
		</label>
	),
);

const StyledPaperSelector = styled(Paper)<IPaperProps, ITheme>`
	input:focus + &,
	input:active + & {
		box-shadow: ${themed(({ paper }) => paper.clickable.hover.boxShadow)};
	}

	input:checked + & {
		box-shadow: ${(props) => getPaperBoxShadow({ selected: true, ...props })};
	}
`;
